const s = {
  name: "ThaiBaht",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24,20c1.2,0.9,2,2.4,2,4c0,2.8-2.2,5-5,5v2h-2v-2h-4V11h4V9h2v2c2.8,0,5,2.2,5,5C26,17.6,25.2,19.1,24,20z
			 M21,27c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3V27z M19,27v-6h-2v6H19z M17,19h2v-6h-2V19z M24,16c0-1.7-1.3-3-3-3v6
			C22.7,19,24,17.7,24,16z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
			s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as ThaiBaht
};
